export interface ServerErrors {
  [key: string]: string[];
}

export interface GenericResponse {
  success: boolean;
  errors: ServerErrors;
}

export interface TimezoneInfo {
  name: string;
  city: string;
  base_offset_display: string;
}

export interface MarkdownResult {
  renderMarkdown: {
    data: string;
  };
}

export interface SettingsInfo {
  escalation_max_repeats: number;
}

export enum ResponseStatus {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export interface QuerySuccess<T> {
  status: ResponseStatus.SUCCESS;
  data: T;
  total?: number;
}

export interface QueryError {
  status: ResponseStatus.ERROR;
  message: ServerErrors;
}

export interface GraphQLResponse<T> {
  response: QuerySuccess<T> | QueryError;
}

export interface MutationStatusResponse {
  response: {
    status: ResponseStatus;
  };
}

export interface GenericMutationResponse {
  response: {status: ResponseStatus.SUCCESS} | QueryError;
}

export enum DateFormatName {
  DEFAULT = "DEFAULT",
  US = "US",
  EU = "EU",
  ISO = "ISO",
}

export enum TimeFormatName {
  DEFAULT = "DEFAULT",
  TWENTY_FOUR_HOUR = "TWENTY_FOUR_HOUR",
  DEFAULT_NO_SECONDS = "DEFAULT_NO_SECONDS",
  TWENTY_FOUR_HOUR_NO_SECONDS = "TWENTY_FOUR_HOUR_NO_SECONDS",
}

export const DateFormat: Record<DateFormatName, string> = {
  DEFAULT: "MMM DD, YYYY",
  US: "MM/DD/YYYY",
  EU: "DD/MM/YYYY",
  ISO: "YYYY-MM-DD",
};

export const TimeFormat: Record<TimeFormatName, string> = {
  DEFAULT: "h:mm:ssa z",
  DEFAULT_NO_SECONDS: "h:mma z",
  TWENTY_FOUR_HOUR: "HH:mm:ss z",
  TWENTY_FOUR_HOUR_NO_SECONDS: "HH:mm z",
};

export const DateFormatDateFns: Record<DateFormatName, string> = {
  DEFAULT: "MMM dd, yyyy",
  US: "MM/dd/yyyy",
  EU: "dd/MM/yyyy",
  ISO: "yyyy-MM-dd",
};

export const TimeFormatDateFns: Record<TimeFormatName, string> = {
  DEFAULT: "h:mm:ss aa",
  DEFAULT_NO_SECONDS: "h:mma",
  TWENTY_FOUR_HOUR: "H:mm:ss",
  TWENTY_FOUR_HOUR_NO_SECONDS: "HH:mm",
};

export const DatePickerFormat: Record<DateFormatName, string> = {
  DEFAULT: "MMM dd, yyyy",
  US: "MM/dd/yyyy",
  EU: "dd/MM/yyyy",
  ISO: "yyyy-MM-dd",
};

export const TimePickerFormat: Record<TimeFormatName, string> = {
  DEFAULT: "h:mm:ss aa",
  DEFAULT_NO_SECONDS: "h:mma",
  TWENTY_FOUR_HOUR: "H:mm:ss",
  TWENTY_FOUR_HOUR_NO_SECONDS: "HH:mm",
};

export enum ProfileTimeFormat {
  DEFAULT = "DEFAULT",
  TWENTY_FOUR_HOUR = "TWENTY_FOUR_HOUR",
}

export const ProfileTimeFormatDisplay: Record<string, string> = {
  [ProfileTimeFormat.DEFAULT]: "12H",
  [ProfileTimeFormat.TWENTY_FOUR_HOUR]: "24H",
};
